import { cache } from '../cache'
import { describeTable } from './describeTable'

describeTable(cache, {
  description:
    'Technical key/value cache for expensive lookups (geocoding, drive durations, mailbox listings) with an expiry. No business meaning; never query it for analysis.',
})
